export default __webpack_public_path__ + "static/SRUS CS1 - Product Specifications & Technical Data-781b46d9d7e6ad550cc7b9905058d29d.pdf";